@if (isLoading()) {
  <app-pan-blank-slate>
    <app-pan-spinner size="lg"></app-pan-spinner>
  </app-pan-blank-slate>
} @else {
  <div class="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
    <app-pan-form-control class="col-span-1">
      <app-pan-floating-label>View Billing For Month</app-pan-floating-label>
      <app-pan-datepicker
        [min]="minDate()"
        [(date)]="monthSelection"
        startView="multi-year"
        (monthSelected)="closeDatePickerEarly($event)"
      ></app-pan-datepicker>
    </app-pan-form-control>
  </div>

  <div>
    <app-pan-section-header title="Subscriptions" class="my-2">
      <app-pan-chip color="info">Total: {{ subscriptionTotal() | currency: "USD" }}</app-pan-chip>

      <app-pan-button
        color="info"
        fill="outline"
        icon="cloud_download"
        action
        (click)="exportCSV(subscriptionGrid, subscriptionFileName())"
      >
        Export
      </app-pan-button>
    </app-pan-section-header>

    <ag-grid-angular
      #subscriptionGrid
      [rowData]="subscriptionTableItems()"
      [columnDefs]="locationColumns"
      [gridOptions]="locationTable"
    ></ag-grid-angular>

    <app-pan-section-header title="Hardware" class="my-2">
      <app-pan-chip color="info">Total: {{ bundleTotal() | currency: "USD" }}</app-pan-chip>

      <app-pan-button color="info" fill="outline" icon="cloud_download" action (click)="exportCSV(hardwareGrid, hardwareFileName())">
        Export
      </app-pan-button>
    </app-pan-section-header>

    <ag-grid-angular
      #hardwareGrid
      [rowData]="bundleTableItems()"
      [columnDefs]="hardwareColumns"
      [gridOptions]="hardwareTable"
    ></ag-grid-angular>
  </div>
}
